import { cn } from "@/lib/utils";
import { useBotbLeaderboardContext } from "../context";

export function TopSubscribe() {
  const { openPrizesModal, hasSubscription, tournamentFinished } = useBotbLeaderboardContext();

  return (
    <div
      className={cn(
        `font-jost lg:mb-0 lg:flex lg:items-center lg:justify-between ${tournamentFinished ? "mx-auto mb-8" : "mb-6"}`
      )}>
      <div className={"mb-3 lg:mb-0 lg:max-w-[666px] lg:relative"}>
        <>
          <div className="max-lg:text-center text-primary text-lg font-bold leading-6 mb-2 lg:text-[32px] lg:leading-[40px]">
            {!tournamentFinished ? "Secure your prize!" : "Here's where you finished!"}
          </div>
          <div className="max-lg:text-center text-sm font-normal leading-5 text-secondary max-lg:mb-3 lg:text-xl lg:leading-6.5">
            {!tournamentFinished ? (
              <>
                Every competition you play earns you points. The more points you collect,{" "}
                <br className="max-lg:hidden" />
                <strong className="font-bold">the bigger your prize!</strong>
              </>
            ) : (
              <>
                The Summer Leaderboard has now ended. Final results are being verified, and all winners will be
                contacted within the next 7 days to arrange their prizes.
              </>
            )}
          </div>
        </>

        <div
          onClick={openPrizesModal}
          className={`flex-center cursor-pointer lg:justify-start lg:absolute lg:top-1.5 ${tournamentFinished ? "lg:right-[34px]" : "lg:right-0"}`}>
          <span className={"text-nav-azure text-[13px] leading-4.5 font-medium lg:text-xl lg:leading-6.5"}>
            View prizes
          </span>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={"size-5 lg:size-6 relative lg:top-0.5"}>
            <path
              d="M8.3335 5.83325L12.5002 9.99992L8.3335 14.1666"
              stroke="#3772FF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      {!tournamentFinished ? (
        <div className="relative overflow-hidden lg:w-full lg:max-w-[497px] bg-gray-4 lg:bg-white rounded-lg">
          <div className="absolute top-0 left-0 px-1.5 lg:px-2 py-0.5 lg:py-[3px] bg-gradient-botb rounded-br-lg">
            <div className="text-[10px] lg:text-xs font-medium leading-[12px] lg:leading-4 text-white whitespace-nowrap">
              SUBSCRIBERS ONLY
            </div>
          </div>

          <div className="flex items-center py-2 lg:py-4 pl-4 lg:pl-5 pr-3 lg:pr-5 gap-2 lg:gap-3 min-h-[64px] lg:min-h-[100px]">
            <div className="flex items-center gap-2 lg:gap-3 pt-2 lg:pt-1">
              <img src="/assets/images/leaderboard/2x.webp" alt="2x points" className="shrink-0 w-10 lg:w-[60px]" />
              <div className="min-w-0 text-xs lg:text-lg font-medium leading-4 lg:leading-6 text-gray-1">
                Subscribers get <span className="font-bold text-secondary">DOUBLE POINTS</span> on all entries!
              </div>
            </div>

            {!hasSubscription ? (
              <a
                href="/botb-pass?utm_medium=leaderboard-everybody-wins"
                className="flex items-center justify-center shrink-0 ml-auto min-h-8 lg:min-h-12 w-[100px] lg:w-[130px] px-2.5 py-1 text-xs lg:text-base font-medium text-center whitespace-nowrap bg-[#3268E8] text-white rounded-lg cursor-pointer">
                Subscribe now
              </a>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
